import { AuthConsumer } from 'providers/authProvider'
import LoadingScreen from '../../components/loading-screen';
export const SilentRenew = () => (
    <AuthConsumer>
        {({ signinSilentCallback }) => {
            signinSilentCallback()
            return <LoadingScreen />;
        }}
    </AuthConsumer>
)
